var map = {
	"./apple-laurel-da-DK.svg": 83650,
	"./apple-laurel-de-DE.svg": 95424,
	"./apple-laurel-en-GB.svg": 21698,
	"./apple-laurel-en-US.svg": 96649,
	"./apple-laurel-es-ES.svg": 69498,
	"./apple-laurel-es-MX.svg": 14617,
	"./apple-laurel-fr-FR.svg": 41338,
	"./apple-laurel-it-IT.svg": 18968,
	"./apple-laurel-nb-NO.svg": 89431,
	"./apple-laurel-nl-NL.svg": 90582,
	"./apple-laurel-pl-PL.svg": 13518,
	"./apple-laurel-pt-BR.svg": 50898,
	"./apple-laurel-pt-PT.svg": 67214,
	"./apple-laurel-sv-SE.svg": 74987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87083;